import React from 'react'
import AccountTypePage from './AccountTypePage'

export default function StdAccount() {
  return (
    <AccountTypePage
      name="STD"
      tagline="A straightforward account with spread-only pricing — no separate commission."
      description={[
        'The STD account bundles all trading costs into the spread, with no per-trade commission. It gives you access to forex, metals, energies, indices, and crypto markets from a single account.',
        'This account is built for traders who want predictable, all-in-one pricing without tracking a separate commission line.',
      ]}
      spec={[
        { label: 'Asset Classes', value: 'Forex, Metals, Energies, Indices, Crypto' },
        { label: 'Spreads From', value: '1.0 pips' },
        { label: 'Commission', value: 'None' },
        { label: 'Leverage up to', value: '1:1000' },
        { label: 'Minimum Deposit', value: '$100' },
        { label: 'Minimum Trade Size', value: '0.01 lots' },
        { label: 'Maximum Total Trade Size', value: 'Unlimited' },
        { label: 'Maximum Single Order Size', value: '50 lots' },
        { label: 'Account Currency', value: 'USD, USDT' },
        { label: 'Order Execution', value: 'Market' },
        { label: 'Margin Call', value: '50%' },
        { label: 'Stop Out', value: '30%' },
        { label: 'Negative Balance Protection', value: 'Yes' },
      ]}
      switchTo={[
        { label: 'ECN', to: '/trading/ecn-account' },
        { label: 'PRO', to: '/trading/pro-account' },
      ]}
    />
  )
}
